import React, { useEffect, useState } from "react";
import {
  Badge,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
  Space,
  Table,
  Tag,
  TreeSelect,
} from "antd";
import moment from "moment";
import {
  ApproveRequestLeaveSPApi,
  ChangeStatusDeNghiChamCongApi,
  listDeNghiPhepDBApi,
  ListLoaiDeNghiApi,
} from "../../../api/deNghiChamCong";
import {
  getFirstDayAndLastDayofMonth,
  openNotificationWithIcon,
  validateMessages,
  validatePermission,
} from "../../Function";
import { useSelector } from "react-redux";
import CheckCircleFilled from "@ant-design/icons/lib/icons/CheckCircleFilled";
import CloseCircleFilled from "@ant-design/icons/lib/icons/CloseCircleFilled";
import { ListBoPhanApi } from "../../../api/getListTeam";
import { CheckCircleOutlined, CheckSquareFilled, CheckSquareOutlined, CloseCircleOutlined, CloseSquareOutlined } from "@ant-design/icons";

const renderStatusTag = (record) => {
  return (
    <Tag
      color={record.background}
      key={record.status}
      style={{
        color: record.color,
        fontWeight: "600",
        borderRadius: 10,
        border: `1px solid ${record.color}`,
      }}
    >
      {record.status}
    </Tag>
  );
};
const { Search } = Input;

const approveRequestLeaveSP = (status, id, whynot) => {
  return ApproveRequestLeaveSPApi({
    listUpdateDenghi: [id],
    id_dn: status,
    lydoKhongduyet: whynot,
  });
};

const ModalKhongDuyet = ({ visible, onCancel, updateData, currentItem }) => {
  const [form] = Form.useForm();
  const onOK = () => {
    form.submit();
  };
  const onCancelModal = () => {
    form.resetFields();
    onCancel();
  };
  const onFinish = (values) => {
    approveRequestLeaveSP(5, currentItem.id, values.lydo)
      .then((r) => {
        updateData();
        onCancelModal();
      })
      .catch((r) => {
        openNotificationWithIcon("error", r.data.error);
      });
  };

  const onFinishFailed = (values) => {
    console.log("Received values of form:", values);
  };

  return (
    <Modal
      open={visible}
      onCancel={onCancelModal}
      onOk={onOK}
      title={"Xác nhận không duyệt đề nghị"}
    >
      <div className={"row"}>
        <Form
          form={form}
          name={"form-khong-duyet-de-nghi"}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          layout={"vertical"}
          validateMessages={validateMessages}
        >
          <div className={"row"}>
            <div className={"col-12"}>
              <Form.Item
                name={"lydo"}
                label={"Lý do không duyệt đề nghị"}
                rules={[{ required: true }]}
              >
                <Input></Input>
              </Form.Item>
            </div>
          </div>
        </Form>
      </div>
    </Modal>
  );
};

const getButtonChangeStatus = (
  record,
  updateData,
  teamPermissions,
  setIsShowModal,
  setCurrentItem
) => {
  const onChangeStatus = (type) => {
    const statusTo = type === "accept" ? 2 : 1;
    // const statusTo = type === "accept" ? 1 : 2;

    ChangeStatusDeNghiChamCongApi({
      listUpdateDenghi: [record.id],
      id_dn: statusTo,
      // maTrangthai: statusTo,
      lydoKhongduyet: "",
    })
      .then((r) => {
        updateData();
      })
      .catch((r) => {
        openNotificationWithIcon("error", r.data.error);
      });
  };

  const onApprove = (status, id) => {
    approveRequestLeaveSP(status, id, "")
      .then((r) => {
        updateData();
      })
      .catch((r) => {
        openNotificationWithIcon("error", r.data.error);
      });
  };
  const arrTeam = teamPermissions
    .filter(
      (item) =>
        (item.phanquyen__ten_pq === "attendanceRequest_accept" ||
          item.phanquyen__ten_pq === "attendanceRequest_reject") &&
        item.team__tenTeam == record.teamDenghi
    )
    .map((item, index) => {
      return item.phanquyen__ten_pq;
    });

  const checkPermissionDuyet = validatePermission(
    arrTeam,
    "attendanceRequest_accept"
  );
  const checkPermissionKhongDuyet = validatePermission(
    arrTeam,
    "attendanceRequest_reject"
  );

  return (
    <>
      <Space size="middle">

        {/* {record.trangthaiDenghi == 3 && checkPermissionDuyet && (
          <a
            style={{ color: "#63ec3d" }}
            onClick={() => onChangeStatus("accept")}
            title="Đã duyệt"
          >
            <CheckCircleFilled style={{ fontSize: 20 }} />
          </a>
        )}
        {record.trangthaiDenghi == 3 && checkPermissionKhongDuyet && (
          <a
            style={{ color: "#d94d4d" }}
            onClick={() => {
              setCurrentItem(record);
              setIsShowModal(true);
            }}
            title="Không phê duyệt"
          >
            <CloseCircleFilled style={{ fontSize: 20 }} />
          </a>
        )} */}


        {[2,3].includes(record.trangthaiDenghi) && checkPermissionDuyet && (
          <a
            style={{ color: "#63ec3d" }}
            onClick={() => onApprove(4, record.id)}
            title="HR đã phê duyệt"
          >
            <CheckSquareOutlined style={{ fontSize: 20 }} />
          </a>
        )}
        {[2,3].includes(record.trangthaiDenghi) && checkPermissionKhongDuyet && (
          <a
            style={{ color: "#d94d4d" }}
            onClick={() => {
              setCurrentItem(record);
              setIsShowModal(true);
            }}
            title="HR không phê duyệt"
          >
            <CloseSquareOutlined style={{ fontSize: 20 }} />
          </a>
        )}

      </Space>
    </>
  );
};

export const NhanSuDeNghiChamCong = () => {
  const defaultPageSize = 50;
  const [pager, setPager] = useState({
    pageSize: defaultPageSize,
    count: 0,
    current: 1,
  });
  const [data, setData] = useState([]);
  const [lsTeam, setLsTeam] = useState([]);
  const [current, setCurrent] = useState(new Date());
  const [firstDay, setFirstDay] = useState(
    getFirstDayAndLastDayofMonth(new Date())[0]
  );
  const [lastDay, setLastDay] = useState(
    getFirstDayAndLastDayofMonth(new Date())[1]
  );
  const [loading, setLoading] = useState(false);
  const [isShowModal, setIsShowModal] = useState(false);
  const [search, setSearch] = useState(null);
  const [currentItem, setCurrentItem] = useState(null);
  const userInfo = useSelector((state) => state.getUserInfo.userInfo);

  const [currentBoPhan, setCurrentBoPhan] = useState([]);
  const [treeDataBoPhan, setTreeDataBoPhan] = useState([]);
  const [lsBoPhan, setLsBoPhan] = useState([]);
  const [currentTeam, setCurrentTeam] = useState([]);
  const [currentRequest, setCurrentRequest] = useState([]);

  const [lsAllTeam, setLsAllTeam] = useState([]);
  const [treeData, setTreeData] = useState([]);
  const [treeDataRequest, setTreeDataRequest] = useState([]);
  const [lsRequest, setLsRequest] = useState([]);
  const [loadingRequest, setLoadingRequest] = useState(false);

  const fetchListLoaiDeNghi = () => {
    ListLoaiDeNghiApi().then((res) => {
      setLsRequest(res.data);
    });
  };


  const fetchListTeam = () => {
    ListBoPhanApi().then((res) => {
      const arrTeam = userInfo.team_permissions
        .filter(
          (item) => item.phanquyen__ten_pq === "attendanceRequest_view_xx"
        )
        .map((item, index) => {
          const idBoPhanForTeam = res.data.filter((itemBP) =>
            itemBP.team.some((itemT) => itemT.id == item.team)
          );
          if (idBoPhanForTeam.length != 0) {
            return {
              idTeam: item.team,
              team: item.team__tenTeam,
              idBoPhan: idBoPhanForTeam[0].id,
            };
          }
          return false;
        })
        .filter((item) => item != false);
      const uniqueArrTeam = [
        ...new Map(arrTeam.map((item) => [item["idTeam"], item])).values(),
      ];
      if (uniqueArrTeam.length === 0) {
        openNotificationWithIcon("error", "Bạn chưa có quyền cho team.");
      }

      const arrIdTeam = uniqueArrTeam.map((item) => item.idTeam);
      const arrBoPhan = res.data.filter(({ team }) =>
        team.some((item) => arrIdTeam.includes(item.id))
      );
      // const arrBoPhan = res.data.filter(itemBP => itemBP.team.map(item=>item.id).filter(x => arrIdTeam.includes(x)))
      if (arrBoPhan.length > 0) {
        setCurrentBoPhan([arrBoPhan[0].id]);
      }
      setLsBoPhan(arrBoPhan);

      setLsAllTeam(uniqueArrTeam);
      if (currentTeam.length === 0) {
        setCurrentTeam([
          arrIdTeam.filter((x) =>
            arrBoPhan[0].team.map((item) => item.id).includes(x)
          )[0],
        ]); // lấy element đầu tiên đặt trong list
        // setCurrentTeam(uniqueArrTeam.map(item=>item.idTeam));
      }
      setLsTeam(
        uniqueArrTeam.filter((x) =>
          arrBoPhan[0].team.map((item) => item.id).includes(x.idTeam)
        )
      );
      // ListTeamOfMemberManagerApi().then(res => {
      //     setLsTeam(res.data)
      //     if (currentTeam.length === 0) {
      //         setCurrentTeam(res.data.map(item => item.idTeam))
      //     }
      // })
    });
  };

  useEffect(() => {
    if (currentTeam.length > 0) {
      fetchListDeNghi({
        listIdTeam: JSON.stringify(currentTeam),
        type_request: currentRequest.length > 0 ? JSON.stringify(currentRequest) : null,
        tuNgay: firstDay,
        denNgay: lastDay,
        page_size: pager.pageSize,
        page: pager.current,
        search,
      });
    } else {
      setData([])
    }
  }, [current, currentTeam]);

  useEffect(() => {
    if (
      userInfo &&
      userInfo.team_permissions &&
      userInfo.team_permissions.length > 0
    ) {
      fetchListTeam();
      fetchListLoaiDeNghi()
    }
  }, [userInfo]);

  const onChangeBoPhan = (value) => {
    setPager({
      pageSize: defaultPageSize,
      count: 0,
      current: 1,
    });
    if (value.length > 0) {
      setCurrentBoPhan(value);
      const lsTeamWith_BP = lsAllTeam.filter((x) => value.includes(x.idBoPhan));
      setLsTeam(lsTeamWith_BP);
      setCurrentTeam([lsTeamWith_BP.map((item) => item.idTeam)[0]]); // 200423
    } else {
      setLsTeam([]);
      setCurrentBoPhan([]);
      setCurrentTeam([]);
    }
  };
  const tPropsConfig_BoPhan = {
    treeData: [
      {
        title:
          currentBoPhan.length > 0 ? (
            <span
              onClick={() => {
                if (!loading) {
                  onChangeBoPhan([]);
                }
              }}
              className="style_SelectTeam"
            >
              Bỏ chọn tất cả
            </span>
          ) : (
            <span
              onClick={() => {
                if (!loading) {
                  onChangeBoPhan(lsBoPhan.map((item) => item.id));
                }
              }}
              className="style_SelectTeam"
            >
              Chọn tất cả
            </span>
          ),
        value: "xxx",
        disableCheckbox: true,
        disabled: true,
        className: "style_treeTeam",
      },
      ...treeDataBoPhan,
    ],
    value: treeDataBoPhan.length > 0 ? currentBoPhan : undefined,
    onChange: onChangeBoPhan,
    treeCheckable: true,
    // showCheckedStrategy: SHOW_PARENT,
    maxTagCount: 2,
    placeholder: "Chọn bộ phận",
    style: { width: "fit-content", minWidth: 200 },
    disabled: loading,
  };

  useEffect(() => {
    const treeDataBoPhan = lsBoPhan.map((item) => {
      return { title: item.tenBophan, value: item.id, key: item.id };
    });
    setTreeDataBoPhan(treeDataBoPhan);
    if (currentBoPhan.length === 0) {
      setCurrentBoPhan(lsBoPhan.map((item) => item.id));
    }
  }, [lsBoPhan]);

  useEffect(() => {
    const treeDataRequest = lsRequest.map((item) => {
      return { title: item.tenLoaiDenghi, value: item.id, key: item.id };
    });
    setTreeDataRequest(treeDataRequest);
    if (currentRequest.length === 0) {
      setCurrentRequest([]);
    }
  }, [lsRequest]);

  const onBlurTeamSelect = () => {
    if (currentTeam.length === 0) {
      openNotificationWithIcon("error", "Lỗi", "Vui lòng chọn ít nhất 1 team");
    }
  };

  const onChangeTeam = (value) => {
    setPager({
      pageSize: defaultPageSize,
      count: 0,
      current: 1,
    });
    if (value.length > 0) {
      setCurrentTeam(value);
    } else {
      setCurrentTeam([]);
    }
  };

  const onChangeRequest = (value) => {
    setPager({
      pageSize: defaultPageSize,
      count: 0,
      current: 1,
    });

    if (value.length > 0) {
      setCurrentRequest(value);
    } else {
      setCurrentRequest([]);
    }
    fetchListDeNghi({
      listIdTeam: JSON.stringify(currentTeam),
      type_request: value.length > 0 ? JSON.stringify(value) : null,
      tuNgay: firstDay,
      denNgay: lastDay,
      page_size: pager.pageSize,
      page: pager.current,
      search,
    });
  };

  const tPropsConfig = {
    treeData: [
      {
        title:
          currentTeam.length > 0 ? (
            <span
              onClick={() => {
                setCurrentTeam([]);
                onChangeTeam([]);
              }}
              style={{
                display: "inline-block",
                color: "#286FBE",
                cursor: "pointer",
              }}
            >
              Bỏ chọn tất cả
            </span>
          ) : (
            <span
              onClick={() => {
                setCurrentTeam(lsTeam.map((item) => item.idTeam));
                onChangeTeam(lsTeam.map((item) => item.idTeam));
              }}
              style={{
                display: "inline-block",
                color: "#286FBE",
                cursor: "pointer",
              }}
            >
              Chọn tất cả
            </span>
          ),
        value: "xxx",
        disableCheckbox: true,
        disabled: true,
      },
      ...treeData,
    ],
    value: treeData.length > 0 ? currentTeam : undefined,
    onChange: onChangeTeam,
    onBlur: onBlurTeamSelect,
    treeCheckable: true,
    // showCheckedStrategy: SHOW_PARENT,
    maxTagCount: 2,
    allowClear: false,
    placeholder: "Chọn team",
    style: { width: "fit-content", minWidth: 200 },
    disabled: loading,
  };

  const tPropsConfig_Request = {
    treeData: [
      {
        title:
          currentRequest.length > 0 ? (
            <span
              onClick={() => {
                if (!loadingRequest) {
                  onChangeRequest([]);
                }
              }}
              className="style_SelectTeam"
            >
              Bỏ chọn tất cả
            </span>
          ) : (
            <span
              onClick={() => {
                if (!loadingRequest) {
                  onChangeRequest(
                    lsRequest && lsRequest.map((item) => item.id)
                  );
                }
              }}
              className="style_SelectTeam"
            >
              Chọn tất cả
            </span>
          ),
        value: "xxx",
        disableCheckbox: true,
        disabled: true,
        className: "style_treeTeam",
      },
      ...treeDataRequest,
    ],
    value: treeDataRequest.length > 0 ? currentRequest : undefined,
    onChange: onChangeRequest,
    treeCheckable: true,
    maxTagCount: 1,
    placeholder: "Chọn loại đề nghị",
    style: { width: "fit-content", minWidth: 200 },
    disabled: loadingRequest,
  };
  useEffect(() => {
    const treeDataTemp = lsTeam.map((item) => {
      return { title: item.team, value: item.idTeam, key: item.idTeam };
    });
    setTreeData(treeDataTemp);
  }, [lsTeam]);

  const fetchListDeNghi = (params = {}) => {
    listDeNghiPhepDBApi({ ...params })
      .then((r) => {
        setData(r.data);
        setPager({
          current: params.page,
          pageSize: params.page_size,
          count: r.data.count,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleChange = (pagination) => {
    const currentPager = { ...pager };
    currentPager.current = pagination.current;
    currentPager.pageSize = pagination.pageSize;
    setPager({ ...currentPager });
    fetchListDeNghi({
      page_size: pagination.pageSize,
      type_request: currentRequest.length > 0 ? JSON.stringify(currentRequest) : null,
      page: pagination.current,
      search,
      tuNgay: firstDay,
      denNgay: lastDay,
      listIdTeam: JSON.stringify(currentTeam),
    });
  };

  const onChangeMonth = (date) => {
    const lsDay = getFirstDayAndLastDayofMonth(date._d);
    setFirstDay(lsDay[0]);
    setLastDay(lsDay[1]);
    setCurrent(date._d);
  };

  const columns = [
    {
      title: "STT",
      dataIndex: "index",
      className: "highlight",
      key: "index",
      render: (value, item, index) =>
        ((pager.current || 1) - 1) * pager.pageSize + index + 1,
      sortDirections: ["descend", "ascend", "descend"],
    },
    {
      title: "Nhân viên",
      dataIndex: "username",
      key: "username",
      className: "highlight",
      filterKey: "username",
      type: "text",
      canSearch: true,
      render: (text, record) => record.msnv + "-" + text,
    },
    {
      title: "Loại đề nghị",
      dataIndex: "tenloaiDenghi",
      className: "highlight",
      key: "tenloaiDenghi",
      filterKey: "tenloaiDenghi",
      render: (text, record) => (
        <span>
          {record.chitietLoaiDenghi
            ? record.tenloaiDenghi + " - " + record.chitietLoaiDenghi
            : record.tenloaiDenghi}
        </span>
      ),
      type: "text",
      canSearch: true,
    },
    {
      title: "Ngày đề nghị",
      dataIndex: "created",
      key: "created",
      className: "highlight",
      filterKey: "created",
      type: "text",
      render: (text) => moment(new Date(text)).format("DD/MM/YYYY"),
      canSearch: true,
    },
    {
      title: "Từ ngày",
      dataIndex: "tuNgay",
      className: "highlight",
      key: "tuNgay",
      filterKey: "tuNgay",
      render: (text, record) => moment(text).format("L"),
      type: "date",
      canSearch: true,
    },
    {
      title: "Đến ngày",
      dataIndex: "denNgay",
      key: "denNgay",
      className: "highlight",
      filterKey: "denNgay",
      render: (text, record) => (text ? moment(text).format("L") : ""),
      type: "date",
      canSearch: true,
    },
    // {
    //   title: "Giờ vào",
    //   dataIndex: "gioVao",
    //   className: "highlight",
    //   key: "gioVao",
    //   filterKey: "gioVao",
    //   render: (text, record) => text && text.toString().substr(0, 5),
    //   type: "text",
    //   canSearch: true,
    // },
    // {
    //   title: "Giờ ra",
    //   dataIndex: "gioRa",
    //   className: "highlight",
    //   key: "gioRa",
    //   filterKey: "gioRa",
    //   render: (text, record) => text && text.toString().substr(0, 5),
    //   type: "date",
    //   canSearch: true,
    // },
    {
      title: "Lý do đề nghị",
      dataIndex: "lydoDenghi",
      className: "highlight",
      key: "lydoDenghi",
      filterKey: "lydoDenghi",
      type: "text",
      canSearch: true,
    },
    {
      title: "Lý do không duyệt",
      dataIndex: "lydoKhongduyet",
      className: "highlight",
      key: "lydoKhongduyet",
      filterKey: "lydoKhongduyet",
      type: "text",
      canSearch: true,
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      className: "highlight",
      key: "status",
      filterKey: "status",
      render: (text, record) => renderStatusTag(record),
      type: "text",
      canSearch: true,
    },
    {
      title: "Thao tác",
      dataIndex: "",
      className: "highlight",
      key: "",
      filterKey: "",
      type: "text",
      align: "center",
      render: (text, record) =>
        getButtonChangeStatus(
          record,
          updateData,
          userInfo.team_permissions,
          setIsShowModal,
          setCurrentItem,
          userInfo.user_permissions
        ),
      canSearch: true,
    },
  ];

  const updateData = () => {
    fetchListDeNghi({
      tuNgay: firstDay,
      denNgay: lastDay,
      listIdTeam: JSON.stringify(currentTeam),
      type_request: currentRequest.length > 0 ? JSON.stringify(currentRequest) : null,
      page_size: pager.pageSize,
      page: pager.current,
      search,
    });
  };
  useEffect(() => {
    if (current && lsTeam.length > 0) {
      const id = setInterval(() => {
        fetchListDeNghi({
          tuNgay: firstDay,
          denNgay: lastDay,
          listIdTeam: JSON.stringify(currentTeam),
          type_request: currentRequest.length > 0 ? JSON.stringify(currentRequest) : null,
          page_size: pager.pageSize,
          page: 1,
          search,
        });
        // setPager({
        //     current: 1,
        //     pageSize: defaultPageSize,
        //     count: 0
        // });
        clearInterval(id);
      }, 500);
      return () => clearInterval(id);
    }
  }, [search]);

  const onSearch = (e) => {
    const search = e.target.value;
    setSearch(search);
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0 font-size-18">
              Đề nghị chấm công -{" "}
              <span style={{ color: "red" }}>Đăng ký phép đặc biệt</span>
            </h4>
            <div className="page-title-right">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <a>Nhân sự</a>
                </li>
                <li className="breadcrumb-item active">Đề nghị chấm công</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div
          className={
            "col-12 d-sm-flex align-items-center justify-content-between mb-2 "
          }
        >
          <div className={"col"}>
            <DatePicker
              style={{ borderRadius: 10 }}
              className={"m-2"}
              onChange={onChangeMonth}
              picker="month"
              format={"MM/YYYY"}
              allowClear={false}
              defaultValue={moment(current)}
            />

            <div className="styleBadge">
              <Badge.Ribbon
                text="Bộ phận"
                color="gray"
                style={{ color: "red" }}
              >
                <TreeSelect {...tPropsConfig_BoPhan} />
              </Badge.Ribbon>
            </div>
            <div className="styleBadge">
              <Badge.Ribbon text="Team" color="gray" style={{ color: "red" }}>
                <TreeSelect {...tPropsConfig} />
              </Badge.Ribbon>
            </div>
            <div className="styleBadge">
              <Badge.Ribbon
                text="Loại đề nghị"
                color="gray"
                style={{ color: "red" }}
              >
                <TreeSelect {...tPropsConfig_Request} />
              </Badge.Ribbon>
            </div>
          </div>
          <Row gutter={[8, 8]} style={{ flexDirection: "row-reverse" }}>
            <Col>
              <Search
                placeholder="Nhập từ khóa tìm kiếm"
                size="normal"
                onChange={onSearch}
                loading={false}
              />
            </Col>
          </Row>
        </div>
      </div>
      <div className="row">
        <Table
          dataSource={data.results}
          columns={columns}
          loading={loading}
          bordered={true}
          className={"custom-table-hover"}
          size={"small"}
          rowKey="id"
          onChange={handleChange}
          rowClassName={(record) =>
            record.number_sendmail >= 3
              ? "expired"
              : "data-row"
          }
          pagination={{
            current: pager.current,
            pageSize: pager.pageSize,
            total: pager.count,
            showSizeChanger: true,
            showQuickJumper: true,
            pageSizeOptions: ["50", "75", "100"],
          }}
        />
      </div>
      <ModalKhongDuyet
        visible={isShowModal}
        onCancel={() => setIsShowModal(false)}
        updateData={updateData}
        currentItem={currentItem}
      />
    </>
  );
};
